<template>


<div class="marquee">
  <div class="marquee__track">
    <span v-for="(item, i) in doubledItems" :key="i" class="marquee__item">{{ item }}</span>
  </div>
</div>

</template>

<script>

// eslint-disable-next-line no-unused-vars
import MySection from '@/components/MySection'

export default {
name: 'References',
    components: {
// eslint-disable-next-line vue/no-unused-components
        MySection,

  },

  setup() {
    const items = [
                   'Abel Mobilfunk',
                   'Allianz Technology',
                   'Blaupunkt',
                   'BMW Forschung und Technik',
                   'Burda Medien',
                   'Chemiepark Linz',
                   'Cisco',
                   'Flughafen München',
                   'Fraunhofer Institut',
                   'Giesecke & Devrient',
                   'HTC',
                   'Huawei Forschungszentrum München',
                   'Klinik Vogtareuth',
                   'Knorr-Bremse Systeme für Schienenfahrzeuge GmbH',
                   'Kontron GmbH',
//                 'KVB',
                   'Landesamt für Digitalisierung, Breitband und Vermessung Bayern',
//                 'mecom Medien-Communikations-Gesellschaft mbH',
                   'Micronas AG',
                   'Münchener Hypothekenbank e.G.',
                   'Nokia-Siemens',
                   'Rohde & Schwarz',
                   'RWE Supply & Trading',
                   'Siemens AG', 
                   'Sky Deutschland',
                   'SoftM AG', 
                   'TransnetBW GmbH',
                   'Vorwerk Deutschland Stiftung & Co. KG',
                   'Winter AG',
                   '4tiitoo'
                  ];

    return {
      items,
      doubledItems: items.concat(items)
    }
  }
}
</script>

/*
view-source:http://michalsnik.github.io/aos/
view-source:http://michalsnik.github.io/aos/dist/css/styles.css
*/

<style lang="scss" scoped>

.marquee {
  overflow: hidden;
  -webkit-mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
}

.marquee__track {
  display: flex;
  width: max-content;
  animation: marquee-scroll 60s linear infinite;

  .marquee:hover & {
    animation-play-state: paused;
  }
}

.marquee__item {
  flex: none;
  white-space: nowrap;
  padding: 0 2.5rem;
  font-size: 1.4rem;
  font-weight: 600;
  opacity: 0.9;
  letter-spacing: 0.3px;
}

@keyframes marquee-scroll {
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
}

@media (prefers-reduced-motion: reduce) {
  .marquee__track {
    animation: none;
  }
  .marquee {
    overflow-x: auto;
  }
}

</style>
